import Budget from '../../pages/admin/Budget/Budget';

function BudgetPageContainer() {
  return <Budget />;
}

export default BudgetPageContainer;
